(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/prolong-button.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/prolong-button.js');

'use strict';

const Button = svs.ui.ReactButton;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom;
const wagerToProlongAtom = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms.wagerToProlongAtom;
const ProlongButton = _ref => {
  let wager = _ref.wager,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? false : _ref$text;
  const setWagerToProlongAtom = useSetAtom(wagerToProlongAtom);
  const handleClick = () => {
    svs.components.analytics.trackEvent({
      category: 'result-lyckoplatsen',
      action: 'click-forlang-spel',
      opt_label: "forlang".concat(desc ? "_".concat(desc) : '')
    });
    setWagerToProlongAtom(wager);
  };
  return React.createElement(Button, {
    onClick: handleClick,
    block: true,
    className: "lp-green",
    size: 300
  }, text ? text : 'Förläng lyckoplatsen');
};
setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.react.components', {
  ProlongButton
});

 })(window);